import { jsx } from 'react/jsx-runtime';
import missingAnnotation from './assets/missingAnnotation.svg';
import noInformation from './assets/noInformation.svg';
import createComponent from './assets/createComponent.svg';
import noBuild from './assets/noBuild.svg';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  {
    generalImg: {
      width: "95%",
      zIndex: 2,
      position: "relative",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, 15%)"
    }
  },
  { name: "BackstageEmptyStateImage" }
);
const EmptyStateImage = ({ missing }) => {
  const classes = useStyles();
  switch (missing) {
    case "field":
      return /* @__PURE__ */ jsx(
        "img",
        {
          src: missingAnnotation,
          className: classes.generalImg,
          alt: "annotation is missing"
        }
      );
    case "info":
      return /* @__PURE__ */ jsx(
        "img",
        {
          src: noInformation,
          alt: "no Information",
          className: classes.generalImg
        }
      );
    case "content":
      return /* @__PURE__ */ jsx(
        "img",
        {
          src: createComponent,
          alt: "create Component",
          className: classes.generalImg
        }
      );
    case "data":
      return /* @__PURE__ */ jsx("img", { src: noBuild, alt: "no Build", className: classes.generalImg });
    default:
      return null;
  }
};

export { EmptyStateImage };
//# sourceMappingURL=EmptyStateImage.esm.js.map
